<template>
  <div class="content">
    <p class="title">费用明细</p>
    <div class="missing-info">
      <el-table ref="table" class="simple-table" :data="paymentDetails" height="100%" highlight-current-row fit border>
        <el-table-column prop="typeName" label="类型" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tableNo" label="表号" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="readTheMeterLastTime" label="上次抄表读数" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="readTheMeterThisTime" label="本次抄表读数" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="currentMonthDosage" label="本月用量" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="amount" label="金额" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pricingScheme" label="计价方案" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="meterReadingDate" label="抄表日期" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <p class="sub-title">合计金额: {{ totalAmount }}</p>
  </div>
</template>

<script>
export default {
  name: 'missingInformation',
  props: {
    isOwner: {
      type: Boolean,
      default: true
    },
    paymentDetails: {
      type: Array,
      default: () => {
        return []
      }
    },
    totalAmount: Number
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  color: #333;
  .title {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .missing-info {
    width: 100%;
    height: calc(100% - 40px);
  }
  .sub-title {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
